export const formatMoney = (smallestUnit, currency = 'USD') =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency }).format((smallestUnit ?? 0) / 100);

export const toSmallestUnit = (displayValue) =>
  Math.round(parseFloat(displayValue || 0) * 100);

export const toPercent = (rate) =>
  `${(+(rate ?? 0) * 100).toFixed(2).replace(/\.00$/, '')}%`;

export const fromPercent = (pct) => parseFloat(pct || 0) / 100;

export const formatDate = (iso) =>
  iso
    ? new Intl.DateTimeFormat('en-US', { day: '2-digit', month: 'short', year: 'numeric' })
        .format(new Date(iso))
    : '—';
